import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { FormikHelpers } from 'formik';
import { message } from 'antd';
import { CashRegistersService } from '../../services';

export type CashRegisterFormValues = {
  name: string;
  amount: string;
  currencyId: string;
};

export const useCashRegisterForm = () => {
  const { id } = useParams<{ id?: string }>();
  const navigate = useNavigate();

  const detail = useQuery(
    ['cash-register', id],
    async () => {
      const result = await CashRegistersService.getById(id!);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    { enabled: !!id, cacheTime: 0 },
  );

  const initialValues = useMemo<CashRegisterFormValues>(() => {
    if (id && detail.data) {
      return { name: detail.data.name, amount: String(detail.data.initialAmount), currencyId: String(detail.data.currency.id) };
    }
    return { name: '', amount: '0', currencyId: '' };
  }, [id, detail.data]);

  const onSubmit = useCallback(
    async (values: CashRegisterFormValues, helpers: FormikHelpers<CashRegisterFormValues>) => {
      const result = await CashRegistersService.create({ id, name: values.name, amount: values.amount, currencyId: values.currencyId });
      if (result.status === 200) {
        message.success(id ? 'Dəyişikliklər saxlanıldı.' : 'Kassa yaradıldı.');
        navigate('/cash-flow/cash-registers');
      } else if (result.status === 422) {
        const e = result.data as Record<string, string>;
        helpers.setErrors({ name: e.cashbox_name, amount: e.amount, currencyId: e.currency_id });
      } else {
        message.error(result.data as string);
      }
      helpers.setSubmitting(false);
    },
    [id, navigate],
  );

  return { initialValues, onSubmit, id, isLoading: !!id && (detail.isLoading || !detail.data) };
};
